// extracted by mini-css-extract-plugin
module.exports = {"disableScroll":"SocialLink_disableScroll__19DiJ","hideInPercy":"SocialLink_hideInPercy__1hiub","socialLink":"SocialLink_socialLink__2W9sa"};